import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BaseButtonSize, BaseInquiryClosingReasons, CloseInquiryFormInterface } from 'base';
import { BaseCustomerInquiryCloseReasons } from '../../_const/base-customer-inquiry-close-reasons.const';

@Component({
  selector: 'base-customer-close-inquiry-form',
  templateUrl: './close-inquiry-form.component.html',
})
export class CloseInquiryFormComponent implements OnInit, OnDestroy {
  @Input() modalRef: NgbModalRef;

  closeInquiryForm: FormGroup<CloseInquiryFormInterface> = new FormGroup({
    reason: new FormControl(BaseInquiryClosingReasons.default as BaseInquiryClosingReasons, { nonNullable: true }),
    justification: new FormControl('', { nonNullable: true }),
  });
  textareaPlaceholder = 'inquiry.closeInquiry.additionalMessagePlaceholder';
  inquiryCloseReasons = BaseCustomerInquiryCloseReasons;
  buttonSizes = BaseButtonSize;

  private destroy$ = new Subject<boolean>();

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.closeInquiryForm.controls.reason.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((reason) => {
      this.textareaPlaceholder =
        reason === 'other'
          ? 'inquiry.closeInquiry.otherReasonOrAdditionalMessagePlaceholder'
          : 'inquiry.closeInquiry.additionalMessagePlaceholder';
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  closeInquiry() {
    this.modalRef.close(this.closingNote());
  }

  private closingNote(): string {
    const reason = this.closeInquiryForm.value.reason
      ? `${this.translateService.instant('inquiry.closeInquiry.reason.' + this.closeInquiryForm.value.reason)}.`
      : '';
    const message = this.closeInquiryForm.value.justification ? `${this.closeInquiryForm.value.justification}` : '';
    return `${reason} ${message}`.trim();
  }
}
